module.exports = __webpack_public_path__ + "static/media/explainit-splash-icon.4973a62b.svg";